import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

interface HistoryState {
    filter: string;
  //  page: number;
}

@Injectable({ providedIn: 'root' })
export class HistoryStateService {
    private state = signal<HistoryState>({ filter: ''});//signal<HistoryState>({ filter: '', page: 1 });
    state$ = this.state.asReadonly();

    constructor(@Inject(PLATFORM_ID) private platformId: Object) {
        if (isPlatformBrowser(this.platformId)) {

            // Filter with Page number from browser
            window.addEventListener('popstate', (event) => {
                const state = event.state as HistoryState | null;
                if (state) this.state.set(state);
            });

        }
    }

    get filter(): string { return this.state().filter??''; }
   // get page(): number { return this.state().page; }

    updateState(newState: Partial<HistoryState>) {

        if (JSON.stringify(newState) === JSON.stringify(this.state())) {
            return
        }
        console.log("Update State: ",newState);
        const updated = { ...this.state(), ...newState };
        this.state.set(updated);
        /**
         * Push the new state to the browser hist ory
         * history.pushState(state, title, url): Adds a new entry to the browser's session history.
         * This is particularly useful for Single-Page Applications (SPAs) to update the URL and history without causing a full page reload.
         *
         * Parameters:
         * state: An object representing the state of the new history entry. This can be retrieved later using the popstate event.
         * title: A string containing the title for the new history entry. This is often ignored by browsers, but is included for future compatibility.
         * url: The new URL for the history entry.
         *
         * This URL is shown in the browser's address bar. It must be of the same origin as the current URL.
         */
        if (isPlatformBrowser(this.platformId)) {
            window.history.pushState(updated, '', this.toUrl(updated));
        }
    }

    private toUrl(state: HistoryState) {
        const params = new URLSearchParams({
            filter: state.filter,
          //  page: String(state.page),
        });
        return `?${params.toString()}`;
    }

    initFromUrl() {
        const params = new URLSearchParams(location.search);
        const filter = params.get('filter') || '';
     //   const page = Number(params.get('page') || '1');
      //  this.state.set({ filter, page });
        this.state.set({ filter, });
    }

    back() {
        if (isPlatformBrowser(this.platformId)) {
            // history.back(): Navigates to the previous page in the session history, similar to clicking the browser's "back" button.
            window.history.back();
        }
    }
    forward() {
        if (isPlatformBrowser(this.platformId)) {
            // history.forward(): Navigates to the next page in the session history, similar to clicking the browser's "forward" button.
            window.history.forward();
        }
    }

    clear(): void {
       // const filter='';
       // const page=1;
       // this.updateState({filter,page});
        this.updateState({ filter: ''});
    }


    clearSearch() {
        const filter='';
       // const page=this.state().page;
       // this.updateState({filter,page});
        this.updateState({ filter: ''});
    }

}